// extracted by mini-css-extract-plugin
export default {"container":"HeaderHooli_container__eRy7B","logo":"HeaderHooli_logo__QcEDL"};